import { debounce } from 'lodash'
import { useEffect, useMemo, useState } from 'react'

export const useDebouncedSearchInput = (searchInput: string, delayMs = 300): string => {
  const [debouncedSearch, setDebouncedSearch] = useState('')

  const debouncedSetSearch = useMemo(
    () =>
      debounce((value: string) => {
        setDebouncedSearch(value.trim())
      }, delayMs),
    [delayMs],
  )

  useEffect(() => {
    debouncedSetSearch(searchInput)
    return () => {
      debouncedSetSearch.cancel()
    }
  }, [searchInput, debouncedSetSearch])

  return debouncedSearch
}
